import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Box,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	FormControl,
	FormControlLabel,
	Grid,
	Radio,
	RadioGroup,
	TextField,
	Typography,
} from "@mui/material";
import { route } from "preact-router";
import { ValidateEmail } from "../Common/helpers";

export default function OnboardingDialog(props) {
	console.log("OnboardingDialog", props);
	const { onClose, open } = props;
	const [complete, setComplete] = useState(false);
	const handleClose = () => {
		onClose();
	};
	const [formData, setFormData] = useState({});
	const handleChange2 = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value }, () => {
			console.log("done");
		});
	};

	const manageSubmit = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				uid: props.uid,
				lname: formData.lastname,
				fname: formData.firstname,
				email: formData.email,
				type: props.cat,
			}),
		};
		fetch("/api/adduser", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
		onClose();
	};
	useEffect(() => {
		if (window.location.href.startsWith("http://localhost") && formData.email === undefined) {
			setFormData({
				...formData,
				email: "guillaume.besse+bk" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
				firstname: "Guigui",
				lastname: "Besse",
			});
		}
	}, []);
	useEffect(() => {
		setComplete(ValidateEmail(formData.email) && formData.firstname.length > 0 && formData.lastname.length > 0);
	}, [formData]);
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.open} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">Inviter un acteur du dossier</DialogTitle>
			<DialogContent dividers>
				<Typography gutterBottom>Vous pouvez inviter en deux clics une personne sur le dossier</Typography>
				<Grid container>
					<Grid item xs={12}>
						<div>
							{" "}
							<FormControl component="fieldset">
								<RadioGroup row aria-label="gender" name="gender" defaultValue="Mme" onChange={handleChange2}>
									<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
									<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
								</RadioGroup>
							</FormControl>
						</div>
						<div>
							<TextField
								id="firstname"
								name="firstname"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Nom"
								fullWidth
								margin="dense"
								size="small"
								value={formData.firstname}
								onChange={handleChange2}
							/>
						</div>
						<div>
							<TextField
								id="lastname"
								name="lastname"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Prénom"
								fullWidth
								margin="dense"
								size="small"
								value={formData.lastname}
								onChange={handleChange2}
							/>
						</div>

						<div>
							<TextField
								id="email"
								name="email"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Email"
								fullWidth
								margin="dense"
								size="small"
								value={formData.email}
								onChange={handleChange2}
							/>
						</div>

						<div>
							<Box
								display="flex"
								justifyContent="flex-end"
								//flexDirection="column"
								alignItems="center"
							>
								<Box>
									<Button onClick={manageSubmit} disabled={!complete}>
										Ajouter
									</Button>
								</Box>
							</Box>
						</div>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
}
